<template>
  <div class="app-box">
    <div class="top-box">
      <div class="header">
        <div class="search-input">
          <el-input
            :placeholder="$t('systemConfig.findDepartment')"
            v-model="searchKey"
            @blur="getDepartment"
            @clear="getDepartment"
            clearable
          ></el-input>
        </div>
        <div class="header-btns">
          <el-button v-if="departmentCreate" class="concelbtn" size="medium" @click="addDepartment" :disabled="addStatus">{{
            $t('systemConfig.addDepartment')
          }}</el-button>
          <el-button v-if="departmentCreate || departmentUpdate" class="savebtn" size="medium" @click="saveDepartment" type="primary">{{
            $t('systemConfig.save')
          }}</el-button>
        </div>
      </div>
    </div>
    <div class="table-box">
      <el-table :data="tableData" @row-click="rowClick" style="width: 100%">
        <el-table-column prop="id" label="序号">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="部门全称">
          <template slot-scope="scope">
            <el-input
              v-if="scope.row.type === 'new' || scope.row.id === activeRow"
              class="hours-input"
              v-model="scope.row.fullName"
              @change="editChange('fullName', scope.row)"
            ></el-input>
            <span v-else>{{ scope.row.fullName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="部门简称" class-name="require">
          <template slot-scope="scope">
            <!-- <el-input v-else class="hours-input" v-model="scope.row.taskItem"></el-input> -->
            <el-input
              v-if="scope.row.type === 'new' || scope.row.id === activeRow"
              class="hours-input"
              v-model="scope.row.name"
              @change="editChange('name', scope.row)"
            ></el-input>
            <span v-else>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <el-input
              v-if="scope.row.type === 'new' || scope.row.id === activeRow"
              class="hours-input"
              v-model="scope.row.description"
              @change="editChange('description', scope.row)"
            ></el-input>
            <span v-else>{{ scope.row.description }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="departmentDelete || scope.row.type === 'new'"
              size="mini"
              @click="deleteRow(scope.row)"
              :disabled="addStatus && scope.row.type !== 'new'"
              >删除</el-button
            >
            <span v-else>无操作权限</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        v-if="count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="count"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import systemConfigApi from '@/api/modules/systemConfigApi.api.js';

export default {
  name: 'DepartmentManagment',
  computed: {
    departmentCreate() {
      return this.$store.state.app.userConfig.permissionsKeys?.DepartmentManagementCreate;
    },
    departmentUpdate() {
      return this.$store.state.app.userConfig.permissionsKeys?.DepartmentManagementUpdate;
    },
    departmentDelete() {
      return this.$store.state.app.userConfig.permissionsKeys?.DepartmentManagementDelete;
    },
  },
  data() {
    return {
      searchKey: '',
      activeRow: '',
      addStatus: false,
      page: 1,
      pageSize: 10,
      count: 0,
      originData: {},
      tableData: [],
      editData: {},
    };
  },
  created() {
    this.getDepartment();
  },
  watch: {
    searchKey: function () {
      this.page = 1;
      this.pageSize = 10;
    },
  },
  methods: {
    async getDepartment() {
      let params = { page: this.page, pagesize: this.pageSize };
      if (this.searchKey) {
        params.nameCont = this.searchKey;
      }
      const res = await systemConfigApi.groups('get', params);
      this.tableData = res?.data?.data?.groups || [];
      this.tableData.forEach(item => (this.originData[item.id] = JSON.parse(JSON.stringify(item))));
      this.count = res?.data?.data?.count || 0;
      this.editData = {};
      this.addStatus = false;
      this.activeRow = '';
    },

    addDepartment() {
      this.addStatus = true;
      this.activeRow = '';
      this.tableData.unshift({
        type: 'new',
        fullName: '',
        name: '',
        description: '',
      });
    },
    editChange(key, row) {
      if (row.type === 'new') {
        return;
      }
      const { id, fullName, name, description } = row;
      const { fullName: f, name: n, description: d } = this.originData[id];
      if (!this.editData[id]) {
        this.editData[id] = { id, fullName, name, description };
      } else {
        if (fullName === f && name === n && description === d) {
          delete this.editData[id];
        } else {
          this.editData[id][key] = row[key];
        }
      }
      // console.log('change:', this.editData);
    },
    async saveDepartment() {
      const row = this.tableData[0] || {};
      const { type, fullName, name, description } = row;
      const groups = Object.keys(this.editData).map(k => this.editData[k]);
      const asyncArr = [];
      if (!name && type === 'new') {
        this.$message.error('请输入部门简称！');
        return;
      }
      if (groups.length) {
        const noName = groups.find(item => !item.name);
        if (noName) {
          this.$message.error('部门简称不能为空，请填写！');
          return;
        }
        asyncArr.push(systemConfigApi.groups('put', { groups }));
        console.log('list:', groups);
      }
      if (type === 'new') {
        asyncArr.push(systemConfigApi.groups('post', { fullName, name, description }));
      }
      if (asyncArr.length) {
        let message = '保存成功！';
        let status = 'success';
        const res = await Promise.all(asyncArr);
        res.forEach(item => {
          if (item && item.status !== 200) {
            message = item.statusText || '保存失败！';
            status = 'error';
          }
        });
        this.$message[status](message);
        this.getDepartment();
      }
    },

    async deleteRow(row) {
      if (row.type === 'new') {
        this.tableData.shift();
        this.addStatus = false;
      }
      if (row.id) {
        this.$confirm('确定要删除该部门吗？')
          .then(async () => {
            const res = await systemConfigApi.groups('delete', { id: row.id });
            if (res && res.status === 200) {
              this.$message.success('删除成功！');
              this.getDepartment();
            }
          })
          .catch(() => {});
      }
    },
    rowClick(row) {
      if (!this.departmentUpdate) {
        return;
      }
      this.activeRow = row.id;
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getDepartment();
    },

    handleCurrentChange(page) {
      this.page = page;
      this.getDepartment();
    },
  },
};
</script>
<style lang="scss" scoped>
.app-box {
  padding: 18px 16px;
  flex-grow: 1;
  overflow-y: scroll;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 51px;
    .header-tit {
      height: 16px;
      line-height: 16px;
      padding-left: 8px;
      border-left: 3px solid#409EFF;
      font-size: 16px;
    }
    .search-input {
      min-width: 300px;
    }
    .header-btns {
      display: flex;
      align-items: center;
      height: 36px;
      font-size: 14px;
      .savebtn {
        margin-left: 16px;
      }
    }
  }

  .top-box,
  .table-box {
    background-color: #fff;
    padding: 10px 24px;
    border-radius: 2px;
    margin-bottom: 18px;
    .edit_from {
      margin-top: 30px;
      display: flex;
      justify-content: flex-start;
      max-width: 1300px;
      min-width: 900px;
      font-size: 14px;

      .tit {
        margin-bottom: 8px;
        i {
          margin-right: 3px;
          color: red;
        }
      }
      .el-form-item {
        margin-bottom: 0;
      }

      .vvww_colOne {
        width: 448px;
      }
      .colOne {
        display: flex;
        flex-direction: column;
        .projectname {
          .el-input {
            width: 100%;
            border-radius: 4px;
            height: 40px;
          }
        }

        .member {
          margin-top: 30px;
          .el-select {
            width: 100%;
            border-radius: 4px;
            height: 40px;
          }
          .multiple {
            margin: 4px 0 0 0;
            display: flex;
            flex-wrap: wrap;
            .el-tag {
              margin: 0px 4px 4px 0;
            }
          }
        }
      }

      .vvww_colTwo {
        width: 320px;
        margin-left: 48px;
      }
      .colTwo {
        display: flex;
        flex-direction: column;
        .director {
          .el-select {
            width: 100%;
            height: 40px;
            border-radius: 4px;
          }
        }

        .time {
          margin-top: 30px;
          ::v-deep .el-date-picker {
            width: 100%;
            border-radius: 4px;
            height: 40px;
          }
        }
      }

      .vvww_colThird {
        width: 320px;
        margin-left: 48px;
      }
      .colThird {
        display: flex;
        flex-direction: column;
        .chief {
          .el-select {
            width: 100%;
            height: 40px;
            border-radius: 4px;
          }
        }
      }
    }
  }

  .bottom-box {
    margin-top: 16px;
    background-color: #fff;
    padding: 20px 24px 32px;
    border-radius: 2px;
  }

  ::v-deep .empty {
    height: 80%;

    .empty__image {
      width: 286px;
      height: 214px;
    }
    &.operation_Management_err {
      .empty__image {
        width: 267px;
        height: 225px;
      }
    }
  }
}
::v-deep.el-table {
  &::before,
  .el-table__fixed::before {
    height: 0;
  }

  .el-table__header-wrapper {
    border: 1px solid #e8eaec;
    .el-table__header th.el-table__cell {
      background-color: #f8f8f8f9;
      color: #515a6e;
      font-weight: 600;
      padding: 6px 0;
      height: 48px;
      box-sizing: border-box;
      border-bottom: 1px solid #e8eaec;
    }
  }

  /* .el-table__empty-block {
    min-height: 350px;
  } */

  th.require {
    .cell::before {
      content: '*';
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .el-table__body-wrapper {
    transform: translateY(-1px);
  }

  .el-table__row {
    border: 1px solid #dcdee2;
    border-color: #dcdee2;
  }
  .el-table__body td.el-table__cell {
    padding: 6px 0;
    height: 40px;
    border-color: #dcdee2;
    &:first-of-type {
      border-left: 1px solid #dcdee2;
    }
    &:last-of-type {
      border-right: 1px solid #dcdee2;
    }

    .hours-input {
      .el-input__inner {
        color: #515a6e;
        border: none;
        text-align: left;
        height: 29px;
        line-height: 29px;
        background-color: #fff;
      }
    }

    .el-button:not(.is-disabled) {
      color: #2d8cf0;
    }
  }
}
.pagination {
  text-align: right;
  margin: 10px;
}
</style>
